import React from "react";
import styles from "./index.module.scss";
import { Sidebar } from "primereact/sidebar";
import { useSearchParams } from "react-router-dom";

interface SortModelProps {
  showModel: boolean;
  setShowModel: React.Dispatch<React.SetStateAction<boolean>>;
}

const sortItems = [
  {
    id: "last_call_date",
    label: "Last Call Date (Recent → Old)",
    sortOrder: "desc"
  },
  {
    id: "investor_name",
    label: "Investor Name (A–Z)",
    sortOrder: "asc"
  },
  {
    id: "property_price",
    label: "Property Price (High → Low)",
    sortOrder: "desc"
  },
  {
    id: "status_priority",
    label: "Status Priority → Interested at top",
    sortOrder: "desc"
  }
];

export default function SortMobile({ showModel, setShowModel }: SortModelProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  // Determine initial selected sort from URL params
  const initialSortId = (() => {
    const sortParam = searchParams.get("sortBy") || "last_call_date";
    return sortItems.find(item => item.id === sortParam)?.id || "last_call_date";
  })();

  const [selectedSortMenuItem, setSelectedSortMenuItem] = React.useState(initialSortId);

  const applySelection = (id: string) => {
    const updatedParams = new URLSearchParams(searchParams);
    const selectedItem = sortItems.find(item => item.id === id);
    if (selectedItem) {
      updatedParams.set("sortBy", selectedItem.id);
      // Optionally persist sortOrder if backend supports it
      // updatedParams.set("sortOrder", selectedItem.sortOrder);
    }
    setSearchParams(updatedParams);
    setShowModel(false);
  };

  return (
    <Sidebar
      visible={showModel}
      position="top"
      onHide={() => setShowModel(false)}
      className={styles.FilterModel}
    >
      <div className={styles.SortSection}>
        <div className={styles.sortMenuMobile}>
          {sortItems.map(item => (
            <div
              key={item.id}
              className={
                selectedSortMenuItem === item.id
                  ? `${styles.sortMenuItem} ${styles.selected}`
                  : styles.sortMenuItem
              }
              onClick={() => {
                setSelectedSortMenuItem(item.id);
                applySelection(item.id);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
    </Sidebar>
  );
}
